"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactActionBlock = _interopRequireDefault(require("@nerdwallet/react-action-block"));

var _reactInputGroup = _interopRequireWildcard(require("@nerdwallet/react-input-group"));

var _reactAccessibility = require("@nerdwallet/react-accessibility");

var _textareaModule = _interopRequireDefault(require("./textarea.module.less"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Displays a multi-line text input box that the user can type into. This
 * component is a stateless visual wrapper on top of the html <textarea> and
 * takes many of the same props.
 */
var Textarea = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _classNames;

  // Determine if we should compose an Input
  // within an InputGroup
  var willRenderInputGroup = (0, _reactInputGroup.shouldRenderInputGroup)(props);

  var className = props.className,
      disabled = props.disabled,
      error = props.error,
      fullWidth = props.fullWidth,
      idProp = props.id,
      inputRef = props.inputRef,
      noResize = props.noResize,
      label = props.label,
      helpMessage = props.helpMessage,
      errorMessage = props.errorMessage,
      tooltip = props.tooltip,
      tooltipPlacement = props.tooltipPlacement,
      dangerouslyForceFocusStyling = props.dangerouslyForceFocusStyling,
      dangerouslyForceHoverStyling = props.dangerouslyForceHoverStyling,
      otherProps = _objectWithoutProperties(props, ["className", "disabled", "error", "fullWidth", "id", "inputRef", "noResize", "label", "helpMessage", "errorMessage", "tooltip", "tooltipPlacement", "dangerouslyForceFocusStyling", "dangerouslyForceHoverStyling"]);

  var id = (0, _reactAccessibility.useId)(idProp);
  var errorMessageId = "".concat(id, "-error-message");
  var helpMessageId = "".concat(id, "-help-message"); // It's safe to unconditionally render both IDs in `aria-describedby`, even
  // if there isn't a help/error message currently being shown. If
  // `aria-describedby` refers to an element that doesn't exist, it just skips it.

  var ariaDescribedByIds = "".concat(errorMessageId, " ").concat(helpMessageId);

  var textarea = /*#__PURE__*/_react["default"].createElement(_reactActionBlock["default"], _extends({
    "aria-invalid": error ? 'true' : undefined,
    "aria-describedby": ariaDescribedByIds,
    component: "textarea",
    disabled: disabled,
    error: error,
    className: (0, _classnames["default"])(_textareaModule["default"].textarea, (_classNames = {}, _defineProperty(_classNames, _textareaModule["default"].fullWidth, fullWidth), _defineProperty(_classNames, _textareaModule["default"].noResize, noResize), _defineProperty(_classNames, className, className && !willRenderInputGroup), _classNames)) // `inputRef` exists mostly for backwards compatibility
    ,
    ref: inputRef || ref,
    id: id,
    dangerouslyForceFocusStyling: dangerouslyForceFocusStyling,
    dangerouslyForceHoverStyling: dangerouslyForceHoverStyling
  }, otherProps));

  if (!willRenderInputGroup) {
    return textarea;
  }

  return /*#__PURE__*/_react["default"].createElement(_reactInputGroup["default"], {
    className: className,
    disabled: disabled,
    error: error,
    errorMessage: errorMessage,
    errorMessageId: errorMessageId,
    helpMessage: helpMessage,
    helpMessageId: helpMessageId,
    input: textarea,
    inputId: id,
    label: label,
    tooltip: tooltip,
    tooltipPlacement: tooltipPlacement
  });
});

Textarea.displayName = 'Textarea';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Textarea.propTypes = {
    /** ID for the textarea element. */
    id: PropTypes.string,

    /** Show the input in an error visual state. */
    error: PropTypes.bool,

    /** When true, sets width to 100% on the input. */
    fullWidth: PropTypes.bool,

    /** Disable interaction and change. */
    disabled: PropTypes.bool,

    /** Disable the browser resize functionality */
    noResize: PropTypes.bool,

    /** Class on the <textarea> element. */
    className: PropTypes.string,

    /** Gives access to the input dom node */
    inputRef: PropTypes.func,

    /** Optional label for the input. */
    label: PropTypes.string,

    /** Optional text to be shown indicating the user is in an error state. */
    errorMessage: PropTypes.node,

    /** Optional help text shown below the input. */
    helpMessage: PropTypes.node,

    /** Optional tooltip shown via an icon next to the label. */
    tooltip: PropTypes.node,

    /** Positioning of tooltip. */
    tooltipPlacement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),

    /** Force the component to use its focus styles. */
    dangerouslyForceFocusStyling: PropTypes.bool,

    /** Force the component to use its hover styles. */
    dangerouslyForceHoverStyling: PropTypes.bool
  };
}

var _default = Textarea;
exports["default"] = _default;